import gql from 'graphql-tag';

export function listLoadSheetWorkflowsQuery() {
  return gql(`
    query ListLoadSheetWorkflows($loadId: Int!, $processDefinitionKey: String) {
      loadSheetWorkflows: listLoadSheetWorkflows(loadId: $loadId, processDefinitionKey: $processDefinitionKey) {
        id
        key
        name
        description
        version
        suspended
      }
      availablePickCount: availablePickCountForLoad(loadId: $loadId)
    }
  `);
}
